import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchWithFallback } from '../../services/apiClient';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import forgotPasswordImage from '../../assets/backgrounds/forgot-password.png';
import './styles.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    document.body.classList.add('forgot-password-page');
    return () => {
      document.body.classList.remove('forgot-password-page');
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    const trimmed = email.trim();
    if (!trimmed) {
      setError('Informe um e-mail válido.');
      return;
    }
    setLoading(true);
    try {
      const url = '/usuarios/recuperar-senha';

      const res = await fetchWithFallback(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json'
        },
        body: JSON.stringify({ emailUSUARIO: trimmed })
      });
      const text = await res.text();
      if (!res.ok) {
        let msg = 'Não foi possível enviar o e-mail de recuperação.';
        try {
          const data = text ? JSON.parse(text) : null;
          msg = data?.message || data?.erro || msg;
        } catch (_) {}
        throw new Error(msg);
      }
      setMessage('Se o e-mail existir, enviaremos instruções para redefinir sua senha.');
    } catch (err) {
      setError(err?.message || 'Erro ao enviar e-mail de recuperação.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <section className="forgot-password-section">
        <div className="forgot-password-container">
          <div className="forgot-password-content">
            <div className="forgot-password-left">
              <div className="forgot-password-form-container">
                <h1></h1>
                <p className="description">
                  Digite seu e-mail e enviaremos instruções para redefinir sua senha.
                </p>

                <form className="forgot-password-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input 
                      type="email" 
                      placeholder="Email"
                      className="form-input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <button type="submit" className="submit-button" disabled={loading}>
                    {loading ? 'Enviando...' : 'Enviar instruções'}
                  </button>
                </form>

                {message && <p className="success-message" style={{ marginTop: 12 }}>{message}</p>}
                {error && <p className="error-message" style={{ marginTop: 12 }}>{error}</p>}

                <div className="forgot-password-footer">
                  <p>
                    Lembrou sua senha? <Link to="/login">Voltar para o login</Link>
                  </p>
                </div>
              </div>
            </div>

            <div className="forgot-password-right">
              <div className="forgot-password-info">
                <h2>Recupere o acesso à sua conta</h2>
                <ul className="benefits-list">
                  <li>Processo simples e seguro</li>
                  <li>Instruções enviadas diretamente para seu e-mail</li>
                  <li>Suporte disponível 24/7</li>
                  <li>Proteção de dados garantida</li>
                </ul>
              </div>
              <img src={forgotPasswordImage} alt="Forgot Password" className="forgot-password-image" />
            </div>
          </div>
        </div>
      </section>
      
    </>
  );
};

export default ForgotPassword; 